import { observer } from 'mobx-react-lite';

import { AppPage } from 'app/common/app-page/features/app-page/app-page';

import { TicketsReportEntityGrid } from '../features/tickets-report-entity-grid';

export const TicketsReportPage = observer(() => {
  return (
    <AppPage perm="PERM_TICKET_READ" noWrapper>
      <TicketsReportEntityGrid />
    </AppPage>
  );
});
